export default function initGroupLogosCarousel(Swiper, Autoplay) {
    // ==========================================================
    // LOGO GROUP
    // ==========================================================
    const groupExpertiseLogos = document.querySelectorAll("[data-group-expertise-logos]");

    groupExpertiseLogos.forEach((slider) => {
        new Swiper(slider, {
            modules: [Autoplay],
            slidesPerView: 1.4,
            spaceBetween: 20,
            watchOverflow: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            speed: 1000,
            loop: true,

            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },

                768: {
                    slidesPerView: 3,
                    spaceBetween: 32,
                },
            },
        });
    });
}